import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram'
      : 'vão se casar'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro265">
      <div className="intro265desktop screen">
        <div className="main-background-C61RwL"></div>
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <p
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL bp1-intro265-animate-enter2">
            <div className="container-center-horizontal">
              <div className="mask-xUsx1L">
                <div className="container-center-horizontal">
                  <div className="overlay"></div>
                  <img
                    className="mask-xLJp7U"
                    src={background || backgroundImg}
                  />
                </div>
              </div>
            </div>
            <div className="vosecasar-xUsx1L bp1-intro265-animate-enter">
              {text}
            </div>
            <div className="container-center-horizontal">
              <h1 className="couple-simplified-nam-xUsx1L bp1-intro265-animate-enter1">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="intro265mobile screen">
        <div className="main-background-C61RwL"></div>
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <p
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL">
            <div className="container-center-horizontal">
              <div className="mask-xUsx1L">
                <div className="container-center-horizontal">
                  <div className="overlay"></div>
                  <img
                    className="mask-xLJp7U"
                    src={background || backgroundImg}
                  />
                </div>
              </div>
            </div>
            <div className="vosecasar-xUsx1L bp2-intro265-animate-enter">
              {text}
            </div>
            <div className="container-center-horizontal">
              <div className="couple-simplified-nam-xUsx1L bp2-intro265-animate-enter1">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
